import styled from 'styled-components/macro';

import mq from '../../../utils/mediaQueriesBp';

export const ResponsiveContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 0 20px;
  margin: 0 auto;
  max-width: 1440px;

  ${mq('laptop')} {
    padding: 0 40px;
  }

  ${mq('desktop')} {
    padding: 0 60px;
  }
`;

export default ResponsiveContainer;
